/**
 * One-shot flag handed from AuthContext (which signs the user out when the JWT
 * expires) to the login screen, so the redirect explains itself instead of
 * looking like a random logout.
 */
const SESSION_EXPIRED_KEY = 'sessionExpired';

export const markSessionExpired = () => {
  try {
    sessionStorage.setItem(SESSION_EXPIRED_KEY, '1');
  } catch (_) { /* sessionStorage unavailable (private browsing) */ }
};

/** Reads and clears the flag — returns true only for the first caller. */
export const consumeSessionExpired = () => {
  try {
    const flagged = sessionStorage.getItem(SESSION_EXPIRED_KEY) === '1';
    if (flagged) sessionStorage.removeItem(SESSION_EXPIRED_KEY);
    return flagged;
  } catch (_) {
    return false;
  }
};
